import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, extends as _extends, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { noop } from '@costar-ui/utils';
import { filterDOMProps } from '@react-aria/utils';
import React__default, { forwardRef, useContext } from 'react';
import { useDialog } from 'react-aria';
import { useContextProps, Provider, HeadingContext } from 'react-aria-components';
import { DialogContext, OverlayTriggerStateContext } from './context.esm.js';
import { DEFAULT_SLOT } from '../../../utils/index.esm.js';

function Dialog(props, ref) {
  var _props$className;
  var originalAriaLabelledby = props['aria-labelledby'];
  var _useContextProps = useContextProps(props, ref, DialogContext);
  var _useContextProps2 = _slicedToArray(_useContextProps, 2);
  props = _useContextProps2[0];
  ref = _useContextProps2[1];
  var _useDialog = useDialog(_objectSpread2(_objectSpread2({}, props), {}, {
      // Only pass aria-labelledby from props, not context.
      // Context is used as a fallback below.
      'aria-labelledby': originalAriaLabelledby
    }),
    // @ts-ignore
    ref),
    dialogProps = _useDialog.dialogProps,
    titleProps = _useDialog.titleProps;
  var state = useContext(OverlayTriggerStateContext);
  var children = props.children;
  if (typeof children === 'function') {
    children = children({
      close: (state === null || state === void 0 ? void 0 : state.close) || noop
    });
  }
  if (!dialogProps['aria-label'] && !dialogProps['aria-labelledby']) {
    // If aria-labelledby exists on props, we know it came from context.
    // Use that as a fallback in case there is no title slot.
    if (props['aria-labelledby']) {
      dialogProps['aria-labelledby'] = props['aria-labelledby'];
    } else {
      // eslint-disable-next-line no-console
      console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.');
    }
  }
  return /*#__PURE__*/React__default.createElement("section", _extends({}, filterDOMProps(props), dialogProps, {
    ref: ref,
    slot: props.slot || undefined,
    style: props.style,
    className: (_props$className = props.className) !== null && _props$className !== void 0 ? _props$className : 'react-aria-Dialog'
  }), /*#__PURE__*/React__default.createElement(Provider
  // eslint-disable-next-line react-perf/jsx-no-new-array-as-prop
  , {
    values: [[HeadingContext, {
      slots: _defineProperty(_defineProperty({}, DEFAULT_SLOT, {}), "title", _objectSpread2(_objectSpread2({}, titleProps), {}, {
        level: 2
      }))
    }]]
  }, children));
}

/**
 * A dialog is an overlay shown above other content in an application.
 */
var _Dialog = /*#__PURE__*/forwardRef(Dialog);
var AriaDialog = _Dialog;

export { AriaDialog as default };
//# sourceMappingURL=dialog.esm.js.map
